import { Cell } from 'react-table'

import { Success, Warning, Running } from './../../../Icons'
import { CellStatus as CellStatusStyled } from './CellStatusStyled'

const statusType: any = {
  'Submitted': <Success size="17px" fill="#2E8540" />,
  'Completed': <Success size="17px" fill="#2E8540" />,
  'Running': <Running size="17px" fill="#D96B02" />,
  'Failed': <Warning size="17px" fill="#CF4845" />
}

export const CellStatus = (cell: string) => ({ row }: Cell) => {
  const value = row.values[cell];

  return (
    <CellStatusStyled>
      {statusType[value]}
      {row.values[cell]}
    </CellStatusStyled>
  )
}
